import { gql } from '@apollo/client';

export default class UserSettingMutation {
    static CREATE_EMAIL_SIGNATURE = gql`
        mutation createEmailSignature($emailSignature: String!) {
            createEmailSignature(emailSignature: $emailSignature) {
                userSettingId
            }
        }
    `;

    static UPDATE_EMAIL_SIGNATURE = gql`
        mutation updateEmailSignature($emailSignature: String!) {
           updateEmailSignature(emailSignature: $emailSignature)
        }
    `;

    static DEACTIVATE_TRUSTED_DEVICE = gql`
        mutation deactivateTrustedDevice($trustedDeviceId: ID!) {
            deactivateTrustedDevice(trustedDeviceId: $trustedDeviceId)
        }
    `;
}
